import React from "react";
import Accordion from 'react-bootstrap/Accordion';
import VersionBuild from "./version_build";
import {Link} from "react-router-dom";

function InfoComponent(){

    return <>
        <div id="info-section" className={'col-md-7- bg-white shadow-sm- mb-5 p-4 pt-5 text-start h-100 align-items-center justify-content-center m-auto'}>

            <small className="text-secondary display-3 opacity-25">
                Інформація
            </small>

            <Accordion
                // defaultActiveKey="0"
                       flush className={'mt-5'}
            >
                {/*OPTIONS*/}
                <Accordion.Item eventKey="4" className={''}>
                    <Accordion.Header>
                        <h5 className={'lead'}>Опції</h5>
                    </Accordion.Header>
                    <Accordion.Body>
                        {/*MODE INFORMATION*/}
                        <div className="title-futures">
                            <small className="text-secondary display-1 opacity-25">
                                Profile Docx
                            </small>
                        </div>
                        <div id="mode-download" className={'text-start mt-5'}>
                            <h2>Опція <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                           xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none"
                                           viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"/>
                            </svg> завантаження</h2>
                            <br/>
                            <p>
                                <b>Викл. опція</b> - Не заповнене поле профайлу буде відображати "{' - Дані відсутні - '.toUpperCase()}" у значенні поля.
                            </p>
                            <p>
                                <b>Вкл. опція</b> - Не заповнене поле профайлу не відображається у docx файлі (Word файлі), але для коректного відкриття: завантажте на Google Drive там відкрийте і завантажте.
                            </p>
                        </div>

                        <div id="mode-clear" className={'text-start mt-5'}>
                            <h2>Опція <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                           xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"/>
                            </svg> очищення</h2>
                            <br/>
                            <p>
                                <b>Викл. опція</b> - Після завантаження поля профайлу не очищаються (залишаються заповненими).
                            </p>
                            <p>
                                <b>Вкл. опція</b> - Після завантаження поля профайлу очищаються (залишаються пустими).
                            </p>
                        </div>

                        <div id="mode-save-download" className={'text-start mt-5'}>
                            <h2>Опція <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                           xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                           viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M19 6c0 1.657-3.134 3-7 3S5 7.657 5 6m14 0c0-1.657-3.134-3-7-3S5 4.343 5 6m14 0v6M5 6v6m0 0c0 1.657 3.134 3 7 3s7-1.343 7-3M5 12v6c0 1.657 3.134 3 7 3s7-1.343 7-3v-6"/>
                            </svg> збереження</h2>
                            <br/>
                            <p>
                                <b>Викл. опція</b> - Після завантаження профайл не зберігається на сервері.
                            </p>
                            <p>
                                <b>Вкл. опція</b> - Після завантаження профайл зберігається на сервері, та буде доступний в мобільному застосунку Docx App.
                            </p>
                        </div>

                    </Accordion.Body>
                </Accordion.Item>

                {/*VERSIONS*/}
                <Accordion.Item eventKey="3">
                    <Accordion.Header>
                        <h5 className={'lead'}>Версії</h5>
                    </Accordion.Header>
                    <Accordion.Body>
                        {/*VERSION*/}

                        <div id={'futures'} className="text-start d-flex flex-column  mt-5">

                            <div className="d-flex justify-content-between align-items-end mb-5">
                                <div className="title-futures">
                                    <small className="text-secondary display-1 opacity-25">
                                        Версії
                                    </small>
                                </div>
                                <div className="symbols d-flex flex-column">
                                    <small className="text-secondary">
                                        ✅ - Впроваджені
                                    </small>
                                    <small className="text-secondary">
                                        ⏳ - Майбутні
                                    </small>
                                </div>
                            </div>

                            <h2>Список версій</h2>
                            <br/>
                            <ul>
                                <li>
                                    ⏳ <b>v.5.1</b>
                                    <br/>
                                    <p>
                                        Share file
                                    </p>
                                </li>
                                <li>
                                    ✅ <b>v.5.0</b>
                                    <br/>
                                    <p>
                                        Оновлено структуру користувацького інтерфейсу, оптимізовано роботу.
                                    </p>
                                    <b>Додано</b>
                                    <p>
                                        <ul>
                                            <li>
                                                Сторніка проектів
                                            </li>
                                            <li>
                                                Інформаційна довідка v.1.0
                                            </li>
                                        </ul>
                                    </p>
                                </li>
                                <li>
                                    ✅ <b>v.4.1</b>
                                    <br/>
                                    <p>
                                        Виправлено помилки, покращено роботу.
                                    </p>
                                </li>
                                <li>
                                    ✅ <b>v.4.0</b>
                                    <br/>
                                    <p>
                                        Оновлено формат профайлу, додано нові поля.
                                    </p>
                                </li>
                                <li>
                                    ✅ <b>v.3.0</b>
                                    <br/>
                                    Оновлено дизайн відповідно нового формату, виправлено помилки, покращено роботу.
                                    <p>
                                        <b>Додано</b>
                                        <ul>
                                            <li>
                                                Розділ документи
                                            </li>
                                            <li>
                                                Банкінг
                                            </li>
                                            <li>
                                                Автотранспорт
                                            </li>
                                            <li>
                                                Адреса
                                            </li>
                                            <li>
                                                Освіта
                                            </li>
                                        </ul>

                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.3.3</b>
                                    <p>
                                        Додано завантаження мобільного застосунку <b>Profile Docx App</b>. Оновленно користувацький інтерфейс блоку інформації.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.3.2</b>
                                    <p>
                                        Виправлено відкриття Word файла після завантаження при виключено режимі завантаження.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.3.1</b>
                                    <p>
                                        Розширено список джерел контакту, родиних зв'язків.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.3</b>
                                    <p>
                                        Інтеграція з мобільним застосунок. Додано авторизацію по QR коду.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.2</b>
                                    <p>
                                        Збереження профайлу, автризація за кодом доступу, доступ до профайлу за QR кодом.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.1</b>
                                    <p>
                                        Додано режим завантаження, очищення полів, інформаційний блок. Інтегровано зміст-навігацію.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.2.0</b>
                                    <p>
                                        Оновлений дизайн, розділення блоків на детальні поля заповнення профайлу.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.1.0</b>
                                    <p>
                                        Генерація профайлу відповідно до шаблону.
                                    </p>
                                </li>

                            </ul>
                        </div>

                    </Accordion.Body>
                </Accordion.Item>

                {/*MOBILE APP*/}
                <Accordion.Item eventKey="2" className={''}>
                    <Accordion.Header>
                        <h5 className={'lead'}>Мобільний застосунок</h5>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div id={'mobile-app'} className="text-start d-flex flex-column  mt-5">

                            <div className="d-flex justify-content-between align-itemsstart mb-5">
                                <div className="title-futures">
                                    <small className="text-secondary lead opacity-25">
                                        Мобільний застосунок
                                    </small>
                                    <h2 className="text-secondary display-3">
                                        Profile Docx App
                                    </h2>
                                </div>
                                <div className="qr-download d-flex flex-column align-items-center">
                                    <img src="/images/qr_app.png" alt="qr_app"  className={'img-fluid'} width={150} />
                                    <small className={'text-secondary opacity-50'}>Скануй QR код</small>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-5">
                                <div className="title-futures">
                                    <h2>Список версій</h2>
                                </div>
                                <div className="symbols d-flex flex-column">
                                    <small className="text-secondary">
                                        ✅ - Впроваджені
                                    </small>
                                    <small className="text-secondary">
                                        ⏳ - Майбутні
                                    </small>
                                </div>
                            </div>

                            <ul>
                                <li>
                                    ⏳ <b>v.1.1</b>
                                    <p>
                                        Додано історію сканування, відновлення досупу до профайлів через email.
                                    </p>
                                </li>

                                <li>
                                    ✅ <b>v.1.0</b>
                                    <p>
                                        Перегляд профайлів, пошук, видалення, перегляд по QR коду, поширення профайлів. Авторизація на сайті через QR код та код доступу.
                                    </p>
                                    <Link to="/download/profile_docx_app_v1.apk" className={'text-decoration-none'} download>

                                        <small className="text-secondary">
                                            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                 xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none"
                                                 viewBox="0 0 24 24">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                      stroke-width="2"
                                                      d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"/>
                                            </svg> Завантажить v1.0
                                        </small>
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>

                {/*PRIVACY_POLICY*/}
                <Accordion.Item eventKey="1" className={''}>
                    <Accordion.Header>
                        <h5 className={'lead'}>Правова інформація</h5>
                    </Accordion.Header>
                    <Accordion.Body>

                        <div className="title-futures">
                            <small className="text-secondary display-1 opacity-25">
                                Політика конфіденційності
                            </small>
                        </div>

                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam assumenda atque dignissimos earum esse eum excepturi fugit iure minima molestiae mollitia nihil nobis, quaerat quasi quo rerum saepe, unde.
                        </p>

                        <div className="title-futures">
                            <small className="text-secondary display-1 opacity-25">
                                Умови користування
                            </small>
                        </div>

                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam assumenda atque dignissimos earum esse eum excepturi fugit iure minima molestiae mollitia nihil nobis, quaerat quasi quo rerum saepe, unde.
                        </p>

                        <div className="title-futures">
                            <small className="text-secondary display-1 opacity-25">
                                Авторське право
                            </small>
                        </div>

                        <p>
                            ©  { new Date().getFullYear() }. Лук'янчук Ярослав Володимирович.
                        </p>

                        <p>
                            <small className="text-muted">
                                <b>Контакти</b>
                            </small>
                            <br/>
                            <small className="text-muted">Веб-сайт:</small> <Link to="https://about.lukyanchuk.com" target={'_blank'} className={'text-dark text-decoration-none'}>www.lukyanchuk.com</Link>
                            <br/>
                            <small className="text-muted">E-mail:</small> <Link to="mailto:yarikthe@gmail.com" target={'_blank'} className={'text-dark text-decoration-none'}>lukyanchuk@tuta.io</Link>
                            <br/>
                            <small className="text-muted">Телефон:</small> <Link to="tel.:+380 (98) 075 13 57" target={'_blank'} className={'text-dark text-decoration-none'}>+380 (98) 075 13 57</Link>
                        </p>

                        <span>
                            Створено з ❤️ в 🇺🇦 <VersionBuild />
                        </span>

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

        </div>
    </>;
}

export default InfoComponent;
